<template>
    <div class="square-boxes">
        <div
            v-if="data.items"
            class="square-boxes-wrapper"
        >
            <SquareBoxesItem
                v-for="(item, index) in data.items"
                :key="index"
                :data="item"
                :has-eager-image="hasEagerImage"
                :page-type="pageType"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ComponentSquareBoxesFragment } from '@/graphql/api'
import SquareBoxesItem from '@/components/cms/component/square-boxes/SquareBoxesItem.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

defineProps<{
    data: ComponentSquareBoxesFragment
    hasEagerImage?: boolean
    pageType: PageType
}>()
</script>

<style lang="scss" scoped>
.square-boxes {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 20px;

    .square-boxes-wrapper {
        width: 100%;
        margin: 0 0 20px;

        @include min-width(640) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            gap: 20px;
        }

        @include min-width(1024) {
            grid-template-columns: repeat(3, 1fr);
        }

        :deep(.square-image-box),
        :deep(.square-text-box) {
            margin: 0 0 20px;

            @include min-width(640) {
                margin: 0;
            }
        }
    }
}
</style>
